import { Component, OnInit } from '@angular/core';
import { Course } from '../../models/course.model';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { User } from 'firebase';
import { AuthService } from 'src/app/services/auth.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-my-courses',
  templateUrl: './my-courses.component.html',
  styleUrls: ['./my-courses.component.css']
})
export class MyCoursesComponent implements OnInit {

  showSpinner: boolean = false;

  courses: Course[] = []

  constructor(
    private authService: AuthService,
    private router: Router,
    private firestore: AngularFirestore,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.getMyCourses();
    this.titleService.setTitle("My Account | CamEdu")
  }

  async getMyCourses() {
    this.showSpinner = true;
    var uid: string
    const user:User = await this.authService.checkAuth().then(result=>{
      return result
    })
    if (user) {
      uid = user.uid;
    }
    
    this.firestore.collection('students').doc(uid).collection('courses').get()
      .subscribe(queriedItems => {
        this.showSpinner = false;
        var courses = queriedItems.docs.map(function (doc) {
          var course = doc.data() as Course;
          const id = doc.id;
          course.id = id;
          return course;
        })
        console.log(courses);
        this.courses = courses;
      })
  }

  routeToCourseDetail(id: string) {
    this.router.navigate(['/my-course/' + id]);
  }

}
